"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StayAlignedPoseT = exports.StayAlignedPose = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class StayAlignedPose {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsStayAlignedPose(bb, obj) {
        return (obj || new StayAlignedPose()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsStayAlignedPose(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new StayAlignedPose()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    upperLegAngleInDeg() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    lowerLegAngleInDeg() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    footAngleInDeg() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    static startStayAlignedPose(builder) {
        builder.startObject(3);
    }
    static addUpperLegAngleInDeg(builder, upperLegAngleInDeg) {
        builder.addFieldFloat32(0, upperLegAngleInDeg, 0.0);
    }
    static addLowerLegAngleInDeg(builder, lowerLegAngleInDeg) {
        builder.addFieldFloat32(1, lowerLegAngleInDeg, 0.0);
    }
    static addFootAngleInDeg(builder, footAngleInDeg) {
        builder.addFieldFloat32(2, footAngleInDeg, 0.0);
    }
    static endStayAlignedPose(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createStayAlignedPose(builder, upperLegAngleInDeg, lowerLegAngleInDeg, footAngleInDeg) {
        StayAlignedPose.startStayAlignedPose(builder);
        StayAlignedPose.addUpperLegAngleInDeg(builder, upperLegAngleInDeg);
        StayAlignedPose.addLowerLegAngleInDeg(builder, lowerLegAngleInDeg);
        StayAlignedPose.addFootAngleInDeg(builder, footAngleInDeg);
        return StayAlignedPose.endStayAlignedPose(builder);
    }
    unpack() {
        return new StayAlignedPoseT(this.upperLegAngleInDeg(), this.lowerLegAngleInDeg(), this.footAngleInDeg());
    }
    unpackTo(_o) {
        _o.upperLegAngleInDeg = this.upperLegAngleInDeg();
        _o.lowerLegAngleInDeg = this.lowerLegAngleInDeg();
        _o.footAngleInDeg = this.footAngleInDeg();
    }
}
exports.StayAlignedPose = StayAlignedPose;
class StayAlignedPoseT {
    constructor(upperLegAngleInDeg = 0.0, lowerLegAngleInDeg = 0.0, footAngleInDeg = 0.0) {
        this.upperLegAngleInDeg = upperLegAngleInDeg;
        this.lowerLegAngleInDeg = lowerLegAngleInDeg;
        this.footAngleInDeg = footAngleInDeg;
    }
    pack(builder) {
        return StayAlignedPose.createStayAlignedPose(builder, this.upperLegAngleInDeg, this.lowerLegAngleInDeg, this.footAngleInDeg);
    }
}
exports.StayAlignedPoseT = StayAlignedPoseT;
